import { useContext, useEffect, useState } from "react";
import { Box, Tab, Tabs, useMediaQuery } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import PageContent from "../../../component/PageContent";
import { useTheme } from "@emotion/react";
import Staged from "./Staged";

const StagedAndTrucks = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const { authToken } = useContext(AuthContext);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageContent>
      <div
        style={{
          position: "relative",
          flexDirection: "row",
          display: useMediaQuery(theme.breakpoints.down("sm"))
            ? "column"
            : "row",
          marginTop: 16,
        }}
      >
        <h2
          style={{
            textAlign: "center",
          }}
        >
          Staged
        </h2>

        <Staged />
      </div>
    </PageContent>
  );
};

export default StagedAndTrucks;
